import React from 'react'
import { Form } from 'semantic-ui-react'

export default class MerchantSettlementTypeField extends React.PureComponent {
  render() {
    const { value, onChange, disabled } = this.props

    const options = [{ key: 'full', text: 'Full', value: 'full' }, { key: 'net', text: 'Net', value: 'net' }]

    return (
      <Form.Select
        required
        fluid
        disabled={disabled}
        label="Full or Net?"
        options={options}
        placeholder="Full or Net?"
        onChange={(e, data) => onChange('merchant_settlement_type', data.value)}
        value={value}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/restaurants/fields/merchantSettlementTypeField.js